import { Close } from '@mui/icons-material';
import { Modal, Box, useMediaQuery, Typography, IconButton, Button } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import { API } from '../../lib/api';
import { useThemePreference } from '../../contexts/ThemeContext';


const columns = [
    {
         field: "organizationName",
        headerName: "Customer",
        flex: 1,          
    },
    {
        field: "name",
        headerName: "Name",
        flex: 1,
    },        
    {
        field: "primaryEmail",
        headerName: "Email",
        flex: 1,
    },   
    {
        field: "phoneNumber",
        headerName: "Phone #",
        flex: 1,
    },                                 
]

const ExistingContactModal = ({ open, handleClose, onSoldTo, onShipTo, onAll}) => {
    const { isDarkMode } = useThemePreference();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [contacts,setContacts] = useState([])
    const isMobile = useMediaQuery('(max-width:600px)');
    const isLaptop = useMediaQuery('(max-width:1280px)')

    const handleSelectionChange = (selection) => setSelectedRows(selection) 

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '85vw' : isLaptop ? '80vw' : '80vw',
        maxHeight: 650,
        overflow: "hidden",
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
    };
  
    const headerFooterStyle = {
        position: 'sticky',
        zIndex: 1,
        backgroundColor: 'background.paper',
    };

    const getSelectedContact = () => {
        const selectedId = selectedRows?.[0];
        if (!selectedId) return null;

        const selectedIdStr = String(selectedId);

        return (contacts || []).find(c => String(c?._id) === selectedIdStr) || null;
    };

    const handleSoldTo = () => {
        const contact = getSelectedContact();
        if (!contact) return;

        // send full object up (parent will patch later)
        onSoldTo?.(contact);
        setSelectedRows([])
        handleClose()
    };

    const handleShipTo = () => {
        const contact = getSelectedContact();
        if (!contact) return;

        onShipTo?.(contact);
        setSelectedRows([])
        handleClose()        
    };

    const handleAll = () => {
        const contact = getSelectedContact();
        if (!contact) return;

        onAll?.(contact)
        setSelectedRows([])
        handleClose()        
    };      


    useEffect(() => {
        async function fetchData() {
            const response = await API.Customers.FetchAll()

            const allContacts = response.flatMap(customer =>
                customer.contacts.map(contact => ({
                  ...contact,
                  organizationName: customer.organizationName,
                  customerId: customer._id,
                  address: customer.address,
                  state: customer.state,
                  city: customer.city,
                  postalCode: customer.postalCode
                }))
            );
            setContacts(allContacts)
        }

        fetchData();
    }, []);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box className="hive-existing-contact-modal" sx={modalStyle}>
                {/* Sticky Header */}
                <Box className="hive-existing-contact-modal-header" sx={{...headerFooterStyle, top: 0, p: 2, borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant="h6">Find Existing Contact</Typography>
                    <IconButton className="hive-existing-contact-modal-close" onClick={handleClose} size="small">
                        <Close />
                    </IconButton>
                </Box>

                {/* Body Goes Here */}
                <Box className="hive-existing-contact-modal-content" sx={{ overflowY: 'auto', flexGrow: 1, p: 2 }}>
                    <DataGridPro
                        className="hive-existing-contact-modal-grid"
                        checkboxSelection
                        rows={contacts}
                        columns={columns}
                        getRowId={(row) => row._id}
                        rowSelectionModel={selectionModel}
                        onRowSelectionModelChange={(model) => {
                            setSelectionModel(model);
                            handleSelectionChange?.(model);
                        }}
                        pagination
                        initialState={{
                        pagination: { paginationModel: { pageSize: 25, page: 0 } },
                        }}
                        pageSizeOptions={[25, 50, 100]}                        
                    />
                </Box>

                {/* Sticky Footer */}
                <Box className="hive-existing-contact-modal-footer" sx={{ ...headerFooterStyle, bottom: 0, p: 2, borderTop: '1px solid #ccc', display: 'flex', justifyContent: 'flex-end', flexWrap: "wrap", gap: 1 }}>
                    <Button variant={isDarkMode ? "outlined" : "contained"} color="primary" sx={{ marginTop: "1em" }} onClick={handleSoldTo}>
                        Append To Sold-To
                    </Button>
                    <Button variant={isDarkMode ? "outlined" : "contained"} color="secondary" sx={{ marginTop: "1em" }} onClick={handleShipTo}>
                        Append To Ship-To
                    </Button>
                    <Button variant={isDarkMode ? "outlined" : "contained"} color="warning" sx={{ marginTop: "1em" }} onClick={handleAll}>
                        Append To All
                    </Button>                    
                </Box>        

            </Box>
        </Modal>        
    )
}

export default ExistingContactModal
